export default "__VITE_ASSET__6fcaa79d__"